<div class="wrapper">
  <div class="plugin-group1">
    <svg-icon [src]="leftIcon" [stretch]="true"></svg-icon>
  </div>

  <div class="middle-content">
    <div class="central-content">
      <div class="main-description">
        <span>{{ mainDescriptionText }}</span>
      </div>

      <div class="secondary-description">
        <span>{{ secondaryDescriptionText }}</span>
      </div>

      <app-new-button
        class="main-button"
        [type]="'primary'"
        [size]="'medium'"
        [svgIconPath]="mainButtonIcon"
        (click)="mainActionClick.emit($event)">
        <span>{{ mainButtonText }}</span>
      </app-new-button>
    </div>
  </div>

  <div class="plugin-group2">
    <svg-icon [src]="rightIcon" [stretch]="true"></svg-icon>
  </div>
</div>

